import { get, post, put } from 'utils/rxfetch'
import { buildURL } from 'utils/urls'

export default () => ({
  // Home
  getEmailsOverviewData(companyId = '', emailDateRange, withoutScanBack) {
    return post(
      `/members-api/search/investigation/email_overview_aggs/?companyFilter=${companyId}`,
      { emailDateRange, withoutScanBack }
    )
  },
  getEmailsOverviewInspectedCount(companyId = '', feDateRange, withoutScanBack) {
    return post(
      buildURL('/members-api/new-stats', {
        companyFilter: companyId,
        inspected: true,
        withoutScanBack,
      }),
      {
        feDateRange,
      }
    )
  },
  getRecentCampaigns(companyId = '') {
    return get(
      `/members-api/homepage/campaigns-preview?companyFilter=${companyId}&count=8&participationPercent=10`
    )
  },
  getThreatTypes(companyId = '', emailDateRange, withoutScanBack) {
    return post(`/members-api/search/investigation/threat_types_aggs/?companyFilter=${companyId}`, {
      emailDateRange,
      withoutScanBack,
    })
  },
  getLicenseInformation(companyId = '') {
    return get(`/members-api/companies/new-license?companyFilter=${companyId}`)
  },
  getMailboxesData(companyId = '') {
    return get(`/members-api/dashboard/mailbox-widget?companyFilter=${companyId}`)
  },
  updateMailboxesData(companyId = '', mailboxesToAdd) {
    return post(`/members-api/dashboard/mailbox-widget?companyFilter=${companyId}`, {
      mailboxesToAdd,
    })
  },
  updateMailboxData(companyId = '') {
    return post(`/members-api/dashboard/mailbox-widget?companyFilter=${companyId}`)
  },
  getIncidentsActivityLog(companyId = '') {
    return get(`/members-api/activity-feed/incidents?companyFilter=${companyId}`)
  },
  getCampaignsActivityLog(companyId = '') {
    return get(`/members-api/activity-feed/campaigns?companyFilter=${companyId}`)
  },
  getCommentsActivityLog(companyId = '') {
    return get(`/members-api/activity-feed/comments?companyFilter=${companyId}`)
  },
  getBlockedAttacksActivityLog(companyId = '') {
    return get(`/members-api/activity-feed/auto-classified?companyFilter=${companyId}`)
  },
  getInsights(companyId = '') {
    return get(`/members-api/insights?companyFilter=${companyId}`)
  },
  dismissInsight(companyId = '', insightKey) {
    const expiry = new Date()
    expiry.setDate(expiry.getDate() + 30)
    return put(
      `/members-api/set-insight-dismissal-expiry?insight=${insightKey}&expiry=${expiry.toISOString()}&companyFilter=${companyId}`
    )
  },
  // Incident Summary
  getThreatProtection(
    companyId = '',
    feDateRange,
    withoutScanBack,
    { mitigation, mailboxAnomaly, topProfiles, mitigationStats, incidentsStats = false }
  ) {
    return post(
      buildURL('/members-api/new-stats', {
        mitigation,
        mailbox_anomaly: mailboxAnomaly,
        top_profiles: topProfiles,
        mitigation_stats: mitigationStats,
        incidents_stats: incidentsStats,
        withoutScanBack,
        companyFilter: companyId,
      }),
      {
        feDateRange,
      }
    )
  },
  getUnclassifiedIncidents(companyId = '', end_user = false) {
    return post(`/members-api/unclassified-widget-view?companyFilter=${companyId}`, { end_user })
  },
  getMostTargetedEmployees(companyId = '', emailDateRange, withoutScanBack) {
    return post(
      `/members-api/search/investigation/targeted_employees_widget/?companyFilter=${companyId}`,
      { emailDateRange, withoutScanBack }
    )
  },
  createIncidentFromMitigationList(companyId = '', eid) {
    return post(`/members-api/irontraps/incident/${eid}/escalate?companyFilter=${companyId}`, {
      from: 'Dashboard',
    })
  },
  getThreatProtectionBannersFilters(companyId = '') {
    return get(`/members-api/deep-dive-filters?companyFilter=${companyId}`)
  },
  getThreatProtectionIncidentsFilters(companyId = '') {
    return post(
      buildURL(`/members-api/incident-deep-dive`, {
        companyFilter: companyId,
        getFilterOptions: true,
      })
    )
  },
  getThreatProtectionIncidentsList(
    companyId = '',
    isCsv,
    isShare,
    page,
    dateFilter = '',
    search = '',
    incidentType = '',
    tags = '',
    departments = '',
    resolvedBy = '',
    reportedBy = '',
    resolutionType = '',
    threatType = '',
    email_share = '',
    message_share = '',
    pageSize = 25
  ) {
    const responseType = isCsv ? 'text' : 'json'
    return post(
      buildURL('/members-api/incident-deep-dive', {
        csv: isCsv,
        share: isShare,
        page,
        pageSize,
        companyFilter: companyId,
        email: email_share,
        message: message_share,
      }),
      {
        search,
        feDateRange: dateFilter,
        query: {
          'Tags Resolution': tags,
          Departments: departments,
          'Reported by': reportedBy,
          'Resolved by': resolvedBy,
          'Incident Type': incidentType,
          'Resolution Type': resolutionType,
          'Threat Type': threatType,
        },
      },
      {},
      responseType
    )
  },

  getThreatProtectionBannersList(companyFilter = '', page, feDateRange, search, bannerType) {
    return post(
      buildURL('/members-api/banner-deep-dive', {
        companyFilter,
      }),
      {
        feDateRange,
        page,
        search,
        banner_type: bannerType,
      }
    )
  },
  // Simulation & Training Summary
  getAwarenessData(companyId = '', cacheKey) {
    return get(`/members-api/reports?cacheKey=${cacheKey}&companyFilter=${companyId}`)
  },
  getAwarenessCacheKey(companyId = '', campaignIds) {
    return post(`/members-api/reports?companyFilter=${companyId}`, { campaignIds })
  },
  getCampaignsIds(
    companyId = '',
    dateFilter,
    selectedIds = null,
    statusFilter,
    languagesFilter,
    search,
    selectAll,
    excludedIds
  ) {
    const params = {
      feDateRange: dateFilter,
      selectedIds,
      statusFilter,
      languagesFilter,
      search,
      selectAll,
      excludedIds,
    }
    return post(`/members-api/campaigns/ids?companyFilter=${companyId}`, params)
  },
  // Old Home
  getResolutionCenterCounts(companyId = '') {
    return get(`/members-api/homepage/resolution-center-preview?companyFilter=${companyId}`)
  },
  getHeartbeat(companyId = '') {
    return get(`/members-api/dashboard/heartbeat?companyFilter=${companyId}`)
  },
  getIncidentsCount(companyId = '') {
    return get(`/members-api/irontraps/reports/counts?companyFilter=${companyId}`)
  },
  // Deep fake widget
  getDeepfakeAnalytic(companyFilter = '', body) {
    return post(`/members-api/deepfake/company/analytics/?companyFilter=${companyFilter}`, body)
  },
  getPhishingWidget(companyId = '', body) {
    return post(`/members-api/search/dashboard-phishing-widget/?companyFilter=${companyId}`, body)
  },
  // Insights widget
  getInsightsDetection(companyId = '', body) {
    return post(`/members-api/search/dashboard-insights-detection?companyFilter=${companyId}`, body)
  },
  getInsightsThreatTypes(companyId = '', body) {
    return post(
      `/members-api/search/dashboard-insights-threat-types?companyFilter=${companyId}`,
      body
    )
  },
  getInsightsVip(companyId = '', body) {
    return post(`/members-api/search/dashboard-insights-vip?companyFilter=${companyId}`, body)
  },
  getResolvedIncidentsWidget(companyId = '', body) {
    return post(
      `/members-api/dashboard/incident-widget-classified?companyFilter=${companyId}`,
      body
    )
  },
  getVipInsightsWidget(companyId = '', body) {
    return post(
      `/members-api/search/dashboard-vip-insights-widget?companyFilter=${companyId}`,
      body
    )
  },
  getSpamWidget(companyId = '', body) {
    return post(`/members-api/search/dashboard-spam-widget/?companyFilter=${companyId}`, body)
  },
})
